import { render, staticRenderFns } from "./ConsoleFooter.vue?vue&type=template&id=4cbff3bf&"
import script from "./ConsoleFooter.vue?vue&type=script&lang=js&"
export * from "./ConsoleFooter.vue?vue&type=script&lang=js&"
import style0 from "./ConsoleFooter.vue?vue&type=style&index=0&id=4cbff3bf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports